import './Main_Navigation_Title.css';
import Icons_Repository from '../Icons/Icons_Repository';
import Component_Title_Notification from '../Components/Component_Title_Notification';
import pwcLogo from '../Images/pwc_logo.png';
import { useEffect, useRef, useState } from 'react';
import { useMsal } from "@azure/msal-react";
 
interface NavigationContent {
  heading: string;
  setCurrentPage: (page: string) => void;
  candidateEmail: string;
}
 
function Main_Navigation_Title({
  heading,
  setCurrentPage,
  candidateEmail
}: NavigationContent) {

  // Create a ref for the input
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // State for notification dropdown
  const [showNotifications, setShowNotifications] = useState(false);
  
  // State for profile dropdown
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  // Click handler to focus the input
  const handleSearchClick = () => {
    console.log('Search clicked!');
    // Focus the input when container is clicked
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  // Toggle profile dropdown
  const handleProfileClick = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  const { instance } = useMsal();
  
  const handleLogout = () => {
  instance.logoutRedirect({
    postLogoutRedirectUri: window.location.origin,
  });
};


  return (
    <div className='title-container'>
      {/* Left section with logo */}
      <div className="nav-left-section">
        <div className="logo-container">
          <img src={pwcLogo} alt="PwC Logo" className="logo-image" />
          <span className="logo-text">Candidate Interview Scheduler</span>
        </div>
      </div>
 
      {/* Center section with search */}
      {/* <div className="nav-center-section">
        <div className="search-container" onClick={handleSearchClick}>
          <Icons_Repository iconName="search1" />
          <input 
            ref={inputRef}
            type="text" 
            className="search-bar" 
            placeholder="Search"
          />
        </div>
      </div> */}
 
      {/* Right section with user info and notifications */}
<div className="nav-right-section">
  {/* Icons group container */}
  <div className="icons-group">
    {/* Home */}
    {/* <div className="home-container">
      <button className="home-button">
        <Icons_Repository iconName="home" />
      </button>
    </div> */}
   
    {/* Notification bell */}
    {/* <div className="notification-container">
      <button 
        className="notification-button"
        onMouseEnter={() => setShowNotifications(true)}
        onMouseLeave={() => setShowNotifications(false)}
      >
        <Icons_Repository iconName="bell" />
        
      </button>

      <Component_Title_Notification
        isVisible={showNotifications}
        onMouseEnter={() => setShowNotifications(true)}
        onMouseLeave={() => setShowNotifications(false)}
      />
    </div> */}
  </div>

  {/* Profile dropdown - separated */}
  <div className="profile-dropdown" ref={dropdownRef}> 
    <div className="profile-button" onClick={handleProfileClick}>
      <div className="profile-avatar">
        <Icons_Repository iconName="profile" />
      </div>
      <span className="profile-name">{candidateEmail}</span>
      <div className={`profile-chevron ${showProfileDropdown ? 'rotated' : ''}`}>
        <Icons_Repository iconName="chevron_down" />
      </div>
    </div>

    {/* Profile Dropdown Menu */}
    {showProfileDropdown && (
      <div className="profile-dropdown-menu">
        <div className="profile-dropdown-header">
          <div className="profile-info">
            <div className="profile-info-name">{candidateEmail}</div>
            <div className="profile-info-role">Candidate</div>
          </div>
        </div>
        <div className="profile-dropdown-content">
          <button className="profile-dropdown-item logout">
            <div className="dropdown-avatar">
              {/* <Icons_Repository iconName="user" /> */}
              <Icons_Repository iconName="x" />
            </div>
            <span onClick={handleLogout}>Logout</span>
          </button>
        </div>
      </div>
    )}
  </div>
</div>
     
    </div>
  );
}
 
export default Main_Navigation_Title;